const USER_KEY = 'user';

let userToken = null;

try {
	userToken = JSON.parse(localStorage.getItem(USER_KEY));
} catch (e) {
	// No user token
	console.log('no user token', e);
}

function loadToken() {
	return userToken;
}

function saveToken(token) {
	userToken = token;
	localStorage.setItem(USER_KEY, JSON.stringify(userToken));
}

function clearToken() {
	saveToken(null);
}

export default {
	loadToken,
	saveToken,
	clearToken,
};
